import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      autoNext={17000}
      notes="System integration demonstration 2"
      visualizer="full"
      terminal={{
        phases: [
          {
            type: 'progress',
            content: 'Initializing Web Interface Modules...',
            duration: 4000,
          },
          {
            type: 'access',
            content: 'Web Systems Online',
          },
          {
            type: 'progress',
            content: 'Loading Synthography Engine...',
            duration: 3500,
          },
          {
            type: 'access',
            content: 'Synthography Systems Ready',
          },
          {
            type: 'progress',
            content: 'Configuring Video Representation Pipeline...',
            duration: 5000,
          },
          {
            type: 'access',
            content: 'Video Systems Initialized',
          },
          {
            type: 'access',
            content: 'Integration Complete - All Systems Operational',
          },
        ],
        config: {
          typingSpeed: 30,
          phaseDelay: 600,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
